/* Quote request (sections/aoc-quote-form.liquid).
   1. Keeps "Your selection" and the hidden fields on the car picked in the buy box.
   2. Adds the options picked in the buy box (the options app's radios) when the form is sent.
   3. With two contact forms on a page (this one and the FAQ's), Shopify shows its sent or error
      message in both after either is sent. The URL ends in #<form id> of the one that was sent,
      so the messages stay only on that form.
   4. It is a pop-up: the buy box's "Request a quote" link opens it without reloading the page
      (which would drop the car the buyer picked), and it opens on its own after a send. */
(function () {
  var root = document.getElementById('request-quote');
  if (!root) return;
  var dialog = document.getElementById('request-quote-dialog');
  var form = root.querySelector('form');
  if (!form) return;

  var variants = {};
  try { variants = JSON.parse(root.querySelector('[data-aq-variants]').textContent); } catch (e) { variants = {}; }

  function field(name) { return form.querySelector('[data-aq-field="' + name + '"]'); }
  function shown(name) { return root.querySelector('[data-aq-show="' + name + '"]'); }

  function pageUrl(id) {
    var input = field('page');
    if (!input) return;
    try { var u = new URL(input.value); u.searchParams.set('variant', id); input.value = u.toString(); } catch (e) { /* keep the server value */ }
  }

  function apply(id) {
    var v = variants[String(id)];
    if (!v) return; // another product's picker (a quick view, a bundle card)
    if (field('fitment')) field('fitment').value = v.t;
    if (field('price')) field('price').value = v.p;
    if (field('sku')) field('sku').value = v.s;
    if (shown('fitment')) shown('fitment').textContent = v.t;
    if (shown('price')) shown('price').textContent = v.p;
    pageUrl(id);
  }

  var fromUrl = new URLSearchParams(location.search).get('variant');
  apply(fromUrl && variants[fromUrl] ? fromUrl : root.getAttribute('data-variant'));

  // The theme dispatches variant:change on the product form without bubbling; a capturing
  // listener on the document still hears it.
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (v && v.id) apply(v.id);
  }, true);
  // Fallback: the theme also sets the buy box's variant input and fires change on it.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name === 'id' && t.closest && t.closest('form[action*="/cart/add"]')) apply(t.value);
  });

  function open() {
    if (!dialog || dialog.open) return;
    dialog.showModal();
    document.documentElement.classList.add('aq-open');
    root.scrollTop = 0;
    var heading = root.querySelector('[data-aq-heading]');
    if (heading) heading.focus({ preventScroll: true });
  }
  if (dialog) {
    dialog.addEventListener('close', function () { document.documentElement.classList.remove('aq-open'); });
    // A click on the dimmed backdrop lands on the dialog itself; the panel fills the rest.
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    root.querySelectorAll('[data-aq-close]').forEach(function (b) {
      b.addEventListener('click', function () { dialog.close(); });
    });
  }

  function optionsPicked() {
    var picked = [];
    document.querySelectorAll('form[action*="/cart/add"] input[name^="mw_opts"]:checked').forEach(function (input) {
      var label = (input.getAttribute('aria-label') || '').trim();
      if (!label || /^none$/i.test(label)) return;
      // Required options name their group in a hidden help text: "Storage Option" is required.
      var group = '';
      var id = (input.name.match(/\[(.+)\]/) || [])[1];
      var help = id && document.getElementById('mw-option-' + id + '-required-helptext');
      if (help) group = ((help.textContent || '').match(/"([^"]+)"/) || [])[1] || '';
      picked.push(group ? group + ': ' + label : label);
    });
    return picked.join('; ');
  }
  form.addEventListener('submit', function () {
    if (field('options')) field('options').value = optionsPicked();
  });

  if (/[?&]contact_posted=/.test(location.search)) {
    if (location.hash === '#' + form.id) {
      document.querySelectorAll('form[action^="/contact"]').forEach(function (other) {
        if (other === form) return;
        other.querySelectorAll('.alert--success, .alert--error').forEach(function (alert) {
          (alert.closest('.field') || alert).hidden = true;
        });
      });
      open(); // show the sent or error message
    } else {
      form.querySelectorAll('[data-aq-status]').forEach(function (el) { el.hidden = true; });
    }
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-aoc-quote-link]');
    if (!link) return;
    e.preventDefault();
    open();
  });

  // A link from another page (/products/<handle>#request-quote) opens it on arrival.
  if (location.hash === '#request-quote') open();
})();
